import { AppLogoMetadata } from './AppLogoMetadata';
import { ModelConfig } from '@ant-design/graphs';
import React from 'react';

import { NodeGroup, NodeImage, NodeRect, NodeText } from './GraphNodeParts';

export interface AppNodeProps {
    cfg: ModelConfig & { detected: boolean; large?: boolean; metadata: AppLogoMetadata };
}

export const AppNode: React.FC<AppNodeProps> = ({ cfg }) => {
	const { height, name, path, width } = cfg.metadata ?? {};
	const hasImage = Boolean(path);
	const maxHeight = cfg.large ? 56 : 28;

	return (
		<NodeGroup
			capture
			draggable>
			<NodeRect
				draggable
				keyshape
				style={ {
					flexDirection: 'row',
					padding: 10
				} }>
				<NodeRect
					draggable
					style={ {
						cursor: 'pointer',
						fill: '#FAFAFA',
						justifyContent: 'center',
						padding: [ 8, 6 ],
						radius: 2,
						stroke: '#D9D9D9',
						width: 'auto'
					} }>
					{ hasImage &&
						<NodeImage
							draggable
							style={ {
								cursor: 'pointer',
								filter: cfg.detected ? 'grayscale(80%)' : undefined,
								height: maxHeight,
								img: path ?? '',
								width: (width || 1) * (maxHeight / (height || maxHeight))
							} } /> }
					{ !hasImage &&
						<NodeText
							draggable
							style={ {
								cursor: 'pointer',
								fill: 'rgba(0,0,0,0.88)',
								fontSize: cfg.large ? 48 : 24
							} }>{ name }
						</NodeText> }
				</NodeRect>
			</NodeRect>
		</NodeGroup>
	);
};
